import { delay } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PaymentMethodListService {

  constructor(private httpClient: HttpClient) {
  }

  getPaymentMethodList(): Observable<any> {
    return this.httpClient.get(
      `${environment.API_ENDPOINT}payment-methods`)
      .pipe(delay(environment.RESPONSE_DELAY));
  }
}
